import { render, staticRenderFns } from "./LeftNavItems.vue?vue&type=template&id=d7becf56"
import script from "./LeftNavItems.vue?vue&type=script&lang=js"
export * from "./LeftNavItems.vue?vue&type=script&lang=js"
import style0 from "./LeftNavItems.vue?vue&type=style&index=0&id=d7becf56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports